/*document.getElementById('language-select').addEventListener('change', function() {
  const selectedLanguage = this.value;
  Shopify.locale.set(selectedLanguage);
});*/
document.getElementById('language-select').addEventListener('change', function() {
  const selectedLanguage = this.value;
  window.location.href = updateQueryStringParameter(window.location.href, 'locale', selectedLanguage);
});

function updateQueryStringParameter(uri, key, value) {
  const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  const separator = uri.indexOf('?') !== -1 ? "&" : "?";
  
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    return uri + separator + key + "=" + value;
  }
}